export default {
  priorityRules: [],
  priorityInfrastructure: [],
  prioritySource: [],
  priorityFlows: [],
  showPriorityModal: false,
  priorityRuleToEdit: null,
  priorityMapData: {
    infrastructure: [],
    source: [],
    inactiveSource: [],
    flow: [],
    borders: [],
    territories: [],
  },
  priorityPeriod: null,
  priorityMapParams: null,
  priorityFlowAction: null,
  forceUpdatePriorityFlows: null,
  priorityLoadingData: 0,
}



// WEBPACK FOOTER //
// ./src/store/priorities/defaults.js